import { t } from "@lingui/macro";
import React from "react";

import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import { VStack, HStack } from "@whoosh/design-system/src/components/primitive";

import { Button } from "../../../../Button/Button";
import { Calendar } from "../../Calendar";
import { MonthNameHeader } from "../../Calendar/components/MonthNameHeader";
import {
  getFollowingMonthStart,
  getPreviousMonth,
} from "../../Calendar/utils/calendarDateUtils";
import { DatePickerPopupProps } from "./types";

export const DatePickerPopup = ({
  monthDateObj,
  startDate,
  endDate,
  setMonthDateObj,
  clubWeekStartsOn,
}: DatePickerPopupProps) => {
  const decrementMonths = () => {
    const previousMonth = getPreviousMonth(monthDateObj);
    setMonthDateObj(previousMonth);
  };

  const incrementMonths = () => {
    const nextMonthObj = getFollowingMonthStart(monthDateObj);
    setMonthDateObj(nextMonthObj);
  };

  return (
    <VStack
      paddingLeft={4}
      paddingBottom={4}
      paddingTop={2}
      testID="datepickerinput-calendar-container"
    >
      <VStack pr={4}>
        <HStack pb={10} justifyContent="space-between" alignItems="center">
          <Button
            variant={"ghost"}
            size={"tiny"}
            leftIcon={<ChevronLeftIcon />}
            onPress={decrementMonths}
            testID="datepickerinput-calendar-prev-month-button"
            accessibilityLabel={t`Previous month button`}
          />
          <MonthNameHeader
            monthDateObj={monthDateObj}
            clubWeekStartsOn={clubWeekStartsOn}
          />
          <Button
            variant={"ghost"}
            size={"tiny"}
            leftIcon={<ChevronRightIcon />}
            onPress={incrementMonths}
            testID="datepickerinput-calendar-next-month-button"
            accessibilityLabel={t`Next month button`}
          />
        </HStack>
        <Calendar
          monthDateObj={monthDateObj}
          startDate={startDate}
          endDate={endDate}
          fillEmptyDays
          showDayOfWeekHeader
          showMonthNameHeader={false}
          clubWeekStartsOn={clubWeekStartsOn}
        />
      </VStack>
    </VStack>
  );
};
